"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanBookingType = exports.PlanBillingMethod = exports.PlanBillingScope = exports.PlanBillingFirstMonthPolicy = exports.PlanThirdPartyIntegration = exports.PlanBillingCancellationPolicy = exports.ExternalShippingService = exports.ExternalShippingType = exports.ExternalDeliveryType = exports.PlanFrequency = exports.PlanCostType = void 0;
/**
 * This enum represents how a plan is priced and determines how we'll calculate the price for
 * estimates and billing
 */
var PlanCostType;
(function (PlanCostType) {
    /**
     * Independently of frequency this plan is free
     */
    PlanCostType["FREE"] = "free";
    /**
     * Price is fixed, check `cost` property
     */
    PlanCostType["FIXED"] = "fixed";
    /**
     * Currently used only for rideshare plans where pricing depends on the route (distance, time, base cost, etc)
     */
    PlanCostType["VARIABLE"] = "variable";
})(PlanCostType || (exports.PlanCostType = PlanCostType = {}));
var PlanFrequency;
(function (PlanFrequency) {
    PlanFrequency["MONTHLY"] = "monthly";
    PlanFrequency["DAILY"] = "daily";
    PlanFrequency["YEARLY"] = "yearly";
    PlanFrequency["PER_TRIP"] = "per_trip";
})(PlanFrequency || (exports.PlanFrequency = PlanFrequency = {}));
// Enum used to define shipping information if an external plans requires it
var ExternalDeliveryType;
(function (ExternalDeliveryType) {
    ExternalDeliveryType["VIRTUAL"] = "virtual";
    ExternalDeliveryType["PHYSICAL"] = "physical";
})(ExternalDeliveryType || (exports.ExternalDeliveryType = ExternalDeliveryType = {}));
var ExternalShippingType;
(function (ExternalShippingType) {
    ExternalShippingType["INDIVIDUAL"] = "individual";
    ExternalShippingType["BULK"] = "bulk";
})(ExternalShippingType || (exports.ExternalShippingType = ExternalShippingType = {}));
var ExternalShippingService;
(function (ExternalShippingService) {
    ExternalShippingService["STANDARD"] = "standard";
    ExternalShippingService["PRIORITY"] = "priority";
    ExternalShippingService["EXPRESS"] = "express";
})(ExternalShippingService || (exports.ExternalShippingService = ExternalShippingService = {}));
/**
 * Determines how the user is billed in the case of a cancellation
 */
var PlanBillingCancellationPolicy;
(function (PlanBillingCancellationPolicy) {
    /**
     * Plan can be canceled at any time and the user will pay up until the bookingEndDate
     */
    PlanBillingCancellationPolicy["FLEXIBLE"] = "flexible";
    /**
     * Frequency cannot be split so if it's a monthly plan and bookingEndDate is set to
     * july 2nd then the user will pay for the whole month of july
     */
    PlanBillingCancellationPolicy["STRICT"] = "strict";
    /**
     * If the end date is before the mid of the month then the user will pay for half a month. If the end
     * date is after mid month then the user will have to pay for a full month
     */
    PlanBillingCancellationPolicy["MODERATE"] = "moderate";
    /**
     * Same as moderate, but the cancellation needs to be requested a month before the end of effective end of the
     * booking. So for example if cancellationRequestDate is on june 10st and bookingEndDate (the date that the user
     * wants to finish his booking) is june 12th then the user will be charged until july 15th (+ 1 month of notice and then
     * moderate rules apply)
     */
    PlanBillingCancellationPolicy["MODERATE_NOTICE"] = "moderate_notice";
    /**
     * Same as MODERATE_NOTICE, but after the month notice is added the policy applied is the same as STRICT
     */
    PlanBillingCancellationPolicy["STRICT_NOTICE"] = "strict_notice";
})(PlanBillingCancellationPolicy || (exports.PlanBillingCancellationPolicy = PlanBillingCancellationPolicy = {}));
var PlanThirdPartyIntegration;
(function (PlanThirdPartyIntegration) {
    PlanThirdPartyIntegration["oneTreePlanted"] = "oneTreePlanted";
    PlanThirdPartyIntegration["commutifiCard"] = "commutifiCard";
})(PlanThirdPartyIntegration || (exports.PlanThirdPartyIntegration = PlanThirdPartyIntegration = {}));
/**
 * Determines how the first month is billed (user can book a plan mid month for example and we need
 * to figure out how this first month will be billed)
 */
var PlanBillingFirstMonthPolicy;
(function (PlanBillingFirstMonthPolicy) {
    /**
     * User will only be billed for the days left in the month
     */
    PlanBillingFirstMonthPolicy["FLEXIBLE"] = "flexible";
    /**
     * User will be billed for the full month independently of when the plan was booked
     */
    PlanBillingFirstMonthPolicy["STRICT"] = "strict";
    /**
     * If the booking happened in the first half of the month the user will pay half the price, otherwise
     * full price is paid
     */
    PlanBillingFirstMonthPolicy["MODERATE"] = "moderate";
})(PlanBillingFirstMonthPolicy || (exports.PlanBillingFirstMonthPolicy = PlanBillingFirstMonthPolicy = {}));
var PlanBillingScope;
(function (PlanBillingScope) {
    PlanBillingScope["USAGE"] = "usage";
    PlanBillingScope["ALLOCATION"] = "allocation";
})(PlanBillingScope || (exports.PlanBillingScope = PlanBillingScope = {}));
var PlanBillingMethod;
(function (PlanBillingMethod) {
    PlanBillingMethod["STRIPE"] = "stripe";
    PlanBillingMethod["EXTERNAL"] = "external";
})(PlanBillingMethod || (exports.PlanBillingMethod = PlanBillingMethod = {}));
var PlanBookingType;
(function (PlanBookingType) {
    /**
     * Plan can be re-booked after cancellation and will be billed on a monthly basis (other frequencies
     * are not supported yet)
     */
    PlanBookingType["RECURRENT"] = "recurrent";
    /**
     * This kind of plan is not related to time and is only billed once
     */
    PlanBookingType["STANDARD"] = "standard";
    /**
     * This plan can only be booked ONCE per user (and obviously is only billed once)
     */
    PlanBookingType["UNIQUE"] = "unique";
    /**
     * This plan can be booked for a single day or a single trip and so is only available on a certain date
     */
    PlanBookingType["SINGULAR"] = "singular";
})(PlanBookingType || (exports.PlanBookingType = PlanBookingType = {}));
//# sourceMappingURL=Plan.js.map